import React from "react";
import {
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Chip,
  Stack,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

export default function StoreCategoriesTable({
  categories,
  onEdit,
  onDelete,
  canManage,
  actionLoadingId,
}) {
  if (!categories.length) {
    return (
      <Paper
        sx={{
          borderRadius: "18px",
          border: "1px solid rgba(148,163,184,0.18)",
          boxShadow: "0 18px 40px rgba(15,23,42,0.06)",
          py: 6,
        }}
      >
        <Stack alignItems="center" spacing={1}>
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: "14px",
              bgcolor: "#f8fafc",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Inventory2OutlinedIcon />
          </Box>

          <Typography
            sx={{
              fontWeight: 800,
              fontSize: 16,
              color: "#0f172a",
            }}
          >
            No hay categorías disponibles
          </Typography>

          <Typography
            sx={{
              fontSize: 13,
              color: "#64748b",
            }}
          >
            Crea la primera categoría del catálogo
          </Typography>
        </Stack>
      </Paper>
    );
  }

  return (
    <Paper
      sx={{
        borderRadius: "18px",
        border: "1px solid rgba(148,163,184,0.18)",
        boxShadow: "0 18px 40px rgba(15,23,42,0.06)",
        overflow: "hidden",
      }}
    >
      <Table>
        <TableHead>
          <TableRow sx={{ bgcolor: "#f8fafc" }}>
            <TableCell sx={{ fontWeight: 800 }}>Código</TableCell>
            <TableCell sx={{ fontWeight: 800 }}>Nombre</TableCell>
            <TableCell sx={{ fontWeight: 800 }}>Sección</TableCell>
            <TableCell sx={{ fontWeight: 800 }}>Estado</TableCell>

            {canManage && (
              <TableCell align="right" sx={{ fontWeight: 800 }}>
                Acciones
              </TableCell>
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {categories.map((c) => {
            const loading = actionLoadingId === c.uuid;

            return (
              <TableRow key={c.uuid} hover>
                <TableCell>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#0f172a",
                      fontSize: 13.4,
                    }}
                  >
                    {c.code}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: "#0f172a",
                      fontSize: 13.4,
                    }}
                  >
                    {c.name}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      color: "#475569",
                      fontSize: 13.2,
                    }}
                  >
                    {c.section_name}
                  </Typography>
                </TableCell>

                <TableCell>
                  <Chip
                    label={c.is_active ? "Activa" : "Inactiva"}
                    size="small"
                    sx={{
                      height: 26,
                      borderRadius: "8px",
                      fontSize: 12,
                      fontWeight: 600,
                      bgcolor: c.is_active
                        ? "rgba(34,197,94,0.12)"
                        : "rgba(220,38,38,0.12)",
                      color: c.is_active ? "#166534" : "#dc2626",
                    }}
                  />
                </TableCell>

                {canManage && (
                  <TableCell align="right">
                    {loading ? (
                      <CircularProgress size={20} />
                    ) : (
                      <Stack
                        direction="row"
                        spacing={0.8}
                        justifyContent="flex-end"
                      >
                        <Button
                          onClick={() => onEdit(c)}
                          variant="outlined"
                          sx={{
                            height: 34,
                            px: 1.2,
                            borderRadius: "9px",
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: 12.6,
                            color: "#334155",
                            borderColor: "rgba(51,65,85,0.18)",
                            "&:hover": {
                              borderColor: "rgba(51,65,85,0.28)",
                              bgcolor: "rgba(148,163,184,0.08)",
                            },
                          }}
                        >
                          Editar
                        </Button>

                        <Button
                          onClick={() => onDelete(c)}
                          variant="outlined"
                          startIcon={<DeleteOutlineRoundedIcon />}
                          sx={{
                            height: 34,
                            px: 1.2,
                            borderRadius: "9px",
                            textTransform: "none",
                            fontWeight: 600,
                            fontSize: 12.6,
                            color: "#dc2626",
                            borderColor: "rgba(220,38,38,0.22)",
                            "&:hover": {
                              borderColor: "rgba(220,38,38,0.32)",
                              bgcolor: "rgba(220,38,38,0.06)",
                            },
                          }}
                        >
                          Eliminar
                        </Button>
                      </Stack>
                    )}
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}